// Auto-generated blog index - DO NOT EDIT MANUALLY
// Generated: 2026-04-01T03:35:11.720Z
// Run: node scripts/generate-blog-index.js

export const blogPosts = [
  {
    "slug": "busy-vs-strategic-real-estate-productivity",
    "title": "Busy vs. Strategic: The Real Estate Productivity Paradox",
    "excerpt": "You're working harder than ever. Your calendar is packed, your phone buzzes constantly, and you collapse into bed exhausted each night. But your business isn't growing. If anything, it feels like you're running faster just to stay in the same place.",
    "category": "Agent Productivity",
    "tags": [
      "real-estate",
      "productivity",
      "agent-productivity"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Busy vs. Strategic: The Real Estate Productivity Paradox",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "buyers-affordability-confusion",
    "title": "Buyers Can't Afford? Or Can't Calculate? The Affordability Crisis Fix",
    "excerpt": "Your buyer says they can afford $400,000. You show them ten houses. They love none of them. Three months later, they still haven't made an offer. What happened?",
    "category": "Tools & Calculators",
    "tags": [
      "real-estate",
      "buyers",
      "tools-calculators"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Buyers Can't Afford? Or Can't Calculate? The Affordability Crisis Fix",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "closing-timeline-chaos",
    "title": "Closing Timeline Chaos: Why Your Clients Don't Understand the Process",
    "excerpt": "\"When will I get my keys?\" It's a simple question, but the answer feels anything but simple. \"Well, we have the inspection, then the appraisal, then the underwriting, then the closing disclosure, then the final walkthrough, then...\" The client's eyes have glazed over.",
    "category": "Tools & Calculators",
    "tags": [
      "real-estate",
      "closing",
      "tools-calculators"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Closing Timeline Chaos: Why Your Clients Don't Understand the Process",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "commission-cap-tracking",
    "title": "Commission Cap Chaos: Are You Close to Keeping 100% of Your Money?",
    "excerpt": "Imagine working the same amount but keeping significantly more of what you earn. For most agents, this isn't a fantasy—it's what happens when you hit your commission cap. The problem? You don't know how close you are to capping.",
    "category": "Commission Tracking",
    "tags": [
      "real-estate",
      "commission",
      "commission-tracking"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Commission Cap Chaos: Are You Close to Keeping 100% of Your Money?",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "commission-split-confusion",
    "title": "Commission Splits Demystified: Stop Confusing Your Clients (and Yourself)",
    "excerpt": "\"So if the house sells for $500,000 and the commission is 6%, you make $30,000?\" The buyer's eyes widen at what seems like a massive payday. You start explaining about listing splits, buyer agent splits, brokerage splits, transaction fees, and taxes. Their eyes glaze over.",
    "category": "Commission Tracking",
    "tags": [
      "real-estate",
      "commission",
      "commission-tracking"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Commission Splits Demystified: Stop Confusing Your Clients (and Yourself)",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "daily-priority-trap",
    "title": "The Daily Priority Trap: Why Most Real Estate Agents Waste 40% of Their Time",
    "excerpt": "You open your laptop at 8 AM with the best intentions. By noon, you've answered seventeen emails, scrolled through three social media apps, responded to two client texts, and rearranged your desk—but you haven't made a single dollar-producing phone call. Sound familiar?",
    "category": "Agent Productivity",
    "tags": [
      "real-estate",
      "productivity",
      "agent-productivity"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "The Daily Priority Trap: Why Most Real Estate Agents Waste 40% of Their Time",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "gci-vs-real-profit",
    "title": "GCI Is a Lie: How to Track Your Real Profit (Not Just Gross Commission)",
    "excerpt": "You closed $400,000 in GCI this year. You post about it on Instagram. You feel successful. But when you look at your actual bank account, something doesn't add up. Where did the money go?",
    "category": "Profit & Loss",
    "tags": [
      "real-estate",
      "income",
      "profit-loss"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "GCI Is a Lie: How to Track Your Real Profit (Not Just Gross Commission)",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "income-tracking-blindspot",
    "title": "The Income Blindspot: Why You Don't Know What You're Making (And How to Fix It)",
    "excerpt": "Here's a question that stops most agents cold: \"What are you actually making this month?\" Not your projected GCI. Not your pipeline value. What will hit your bank account after splits, fees, taxes, and expenses?",
    "category": "Profit & Loss",
    "tags": [
      "real-estate",
      "income",
      "profit-loss"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "The Income Blindspot: Why You Don't Know What You're Making (And How to Fix It)",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "investor-analysis-tools",
    "title": "Stop Losing Investor Clients: Professional Analysis Tools That Close Deals",
    "excerpt": "The investor client asks about cash flow on a duplex. You scramble for a calculator, pull up a spreadsheet template, or worse—admit you don't have those numbers ready. The investor smiles politely but you can see it in their eyes: they're already planning to call the next agent.",
    "category": "Tools & Calculators",
    "tags": [
      "real-estate",
      "investing",
      "calculators",
      "tools-calculators"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Stop Losing Investor Clients: Professional Analysis Tools That Close Deals",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "mortgage-calculator-buyer-confusion",
    "title": "Why Your Buyers Don't Understand Their Purchasing Power (And How to Fix It)",
    "excerpt": "\"I think I can afford around $400,000,\" says the buyer who's pre-approved for $320,000.",
    "category": "Tools & Calculators",
    "tags": [
      "real-estate",
      "buyers",
      "calculators",
      "tools-calculators"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Why Your Buyers Don't Understand Their Purchasing Power (And How to Fix It)",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "seller-net-sheet-struggles",
    "title": "The Seller Net Sheet Mistake That's Costing You Listings",
    "excerpt": "You're in the listing appointment. The seller asks, \"So how much will I actually walk away with?\"",
    "category": "Tools & Calculators",
    "tags": [
      "real-estate",
      "sellers",
      "tools-calculators"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "The Seller Net Sheet Mistake That's Costing You Listings",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  },
  {
    "slug": "sellers-proceeds-confusion",
    "title": "Seller Shocked by Their Proceeds? How to Set Expectations Early",
    "excerpt": "The house sells for $450,000. The seller expects to walk away with $420,000. At closing, they receive $387,000. The look on their face—that mixture of confusion, disappointment, and suspicion directed at you—can kill your reputation faster than any online review.",
    "category": "Tools & Calculators",
    "tags": [
      "real-estate",
      "sellers",
      "tools-calculators"
    ],
    "publishedAt": "2026-03-29T12:00:00Z",
    "estimatedReadTime": 3,
    "featuredImage": {
      "url": "/images/blog/featured/default-blog.svg",
      "alt": "Seller Shocked by Their Proceeds? How to Set Expectations Early",
      "width": 1200,
      "height": 630
    },
    "author": {
      "name": "I Need Numbers Team",
      "role": "Real Estate Tools & Insights",
      "avatar": "/images/avatars/inn-team.webp"
    },
    "status": "published"
  }
];

export const categories = [
  "AI Coaching",
  "Agent Productivity",
  "Business Planning",
  "Commission Tracking",
  "Industry Insights",
  "Profit & Loss",
  "Tools & Calculators"
];

export const tags = [
  "agent-productivity",
  "buyers",
  "calculators",
  "closing",
  "commission",
  "commission-tracking",
  "income",
  "investing",
  "productivity",
  "profit-loss",
  "real-estate",
  "sellers",
  "tools-calculators"
];
